<div class="ui-g">
    <div class="ui-g-12">
        <button (click)="location.back()" pButton type="button" icon="pi pi-chevron-left" class="ui-button-info" style="margin-right: 20px;" label="{{ 'back_btn' | translate }}"></button>
        <h3 style="display: inline-block;" class="section-header">{{ 'user_full_details' | translate }}</h3>
    </div>
</div>

<p-panel header="{{ 'user_full_details' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowUserDetails()" [style]="{'margin-bottom':'10px'}">
    <div style="margin-top: 20px;">
        <app-user-details-form  *ngIf="showUserDetails" [isAdmin]="true" [userId]="userId"></app-user-details-form>
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'commission' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowCommission()" [style]="{'margin-bottom':'10px'}">
    <div>
        <span *ngIf="showCommission" class="tx-12" style="display: block;">{{ 'commission_desc' | translate }}</span>
        <app-arranger-commission-form *ngIf="showCommission" [userId]="userId"></app-arranger-commission-form>
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'contract_date_sign' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="showContractSignDate = true;" [style]="{'margin-bottom':'10px'}">
    <div>
        <span *ngIf="showContractSignDate" class="tx-12" style="display: block;">{{ 'contract_date_sign' | translate }}</span>
        <app-arranger-contract-date-form *ngIf="showContractSignDate" [userId]="userId"></app-arranger-contract-date-form>
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'arranger_full_details' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowArrangerDetails()" [style]="{'margin-bottom':'10px'}">
    <div>
        <app-arranger-details-form  *ngIf="showArrangerDetails" [isAdmin]="true" [userId]="userId"></app-arranger-details-form>
    </div>
</p-panel>

<p-panel header="{{ 'user_history' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowUserHistory()" [style]="{'margin-bottom':'10px'}">
    <div style="margin-top: 2px;">
        <app-user-audit-history *ngIf="showUserHistory" [userId]="userId"></app-user-audit-history>
    </div>
</p-panel>

<p-panel header="{{ 'orders' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowUserOrders()" [style]="{'margin-bottom':'10px'}">
    <div>
        TODO :Zamówienia użytkownika
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'notes' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowNotes()" [style]="{'margin-bottom':'10px'}">
    <div>
        <app-note-list [userId]="userId"></app-note-list>
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'transaction' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowTransaction()" [style]="{'margin-bottom':'10px'}">
    <div>
        <app-profits [userId]="userId"></app-profits>
    </div>
</p-panel>

<p-panel *ngIf="role == 'arranger'" header="{{ 'contracts' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowContracts()" [style]="{'margin-bottom':'10px'}" class="arranger-contracts">
    <div>
        <app-contracts [userId]="userId"></app-contracts>
    </div>
</p-panel>


<p-panel header="Doładowanie konta" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowPrepaids()" [style]="{'margin-bottom':'10px'}">
    <div style="margin-top: 20px;">
        <app-prepaid-management  *ngIf="showPrepaids" [userId]="userId"></app-prepaid-management>
    </div>
</p-panel>

<p-panel *ngIf="role == 'customer'" header="{{ 'Newsletter' | translate }}" [toggleable]="true" [collapsed]="true" (onBeforeToggle)="onShowNewsletter()" [style]="{'margin-bottom':'10px'}" class="arranger-contracts">
    <div>
        <app-newsletter-options [adminUserId]="userId"></app-newsletter-options>
    </div>
</p-panel>
